/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { CarpsaleHistoryManagementShowItemResponse } from './CarpsaleHistoryManagementShowItemResponse';

export type CarpsaleHistoryManagementShowItemResponseApiRespoonse = {
    data?: CarpsaleHistoryManagementShowItemResponse;
    status?: CarpsaleHistoryManagementShowItemResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace CarpsaleHistoryManagementShowItemResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

